import { axiosInstance, ENDPOINT } from 'common/constants';
import { handleResponse } from 'common/helpers';

export const getReleaseNotes = params =>
  handleResponse(axiosInstance.get(ENDPOINT.RELEASE_NOTES, { params }));

export const getReleaseNote = noteId =>
  handleResponse(axiosInstance.get(ENDPOINT.RELEASE_NOTE(noteId)));

export const createReleaseNote = note =>
  handleResponse(axiosInstance.post(ENDPOINT.RELEASE_NOTES, note));

export const updateReleaseNote = (noteId, note) =>
  handleResponse(axiosInstance.put(ENDPOINT.RELEASE_NOTE(noteId), note));

export const deleteReleaseNote = noteId =>
  handleResponse(axiosInstance.delete(ENDPOINT.RELEASE_NOTE(noteId)));

// One action for many notes; the API applies it to all of them or to none.
export const bulkUpdateNotes = (ids, action) =>
  handleResponse(axiosInstance.post(ENDPOINT.RELEASE_NOTES_BULK, { ids, action }));

export const getReleases = scope =>
  handleResponse(axiosInstance.get(ENDPOINT.RELEASE_NOTES_RELEASES, { params: { scope } }));

export const updateRelease = (releaseId, release) =>
  handleResponse(axiosInstance.put(ENDPOINT.RELEASE_NOTES_RELEASE(releaseId), release));

export const deleteRelease = releaseId =>
  handleResponse(axiosInstance.delete(ENDPOINT.RELEASE_NOTES_RELEASE(releaseId)));

export const getUnreadCount = () =>
  handleResponse(axiosInstance.get(ENDPOINT.RELEASE_NOTES_UNREAD_COUNT));

// `onProgress` hears how much of the file has been sent, as a whole percentage.
export const uploadImage = (file, onProgress) => {
  const data = new FormData();
  data.append('image', file, file.name || 'screenshot.png');
  return handleResponse(axiosInstance.post(ENDPOINT.RELEASE_NOTES_IMAGES, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (event) => {
      if (onProgress && event.total) onProgress(Math.round((event.loaded * 100) / event.total));
    }
  }));
};

export const markSeen = () =>
  handleResponse(axiosInstance.post(ENDPOINT.RELEASE_NOTES_SEEN));

// Petasense's live notes for a partner's admins, with the partner's decision on each.
export const getPetasenseNotes = decision =>
  handleResponse(axiosInstance.get(ENDPOINT.RELEASE_NOTES_PETASENSE, { params: { decision } }));

export const skipPetasenseNote = noteId =>
  handleResponse(axiosInstance.put(ENDPOINT.RELEASE_NOTES_PETASENSE_DECISION(noteId), { decision: 'skipped' }));

export const undoPetasenseDecision = noteId =>
  handleResponse(axiosInstance.delete(ENDPOINT.RELEASE_NOTES_PETASENSE_DECISION(noteId)));

// A Petasense note's text for a new partner draft; nothing is saved.
export const getPetasenseTemplate = noteId =>
  handleResponse(axiosInstance.get(ENDPOINT.RELEASE_NOTES_PETASENSE_TEMPLATE(noteId)));
